(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password-header"]) return;
  try {
    
  function initSdpMode() {
    const buttons = document.querySelectorAll('[data-sdp-mode-toggle]');
    function sync(mode) {
      document.documentElement.dataset.sdpMode = mode;
      buttons.forEach(button => {
        button.setAttribute('aria-pressed', String(mode === 'night'));
        button.textContent = mode === 'night' ? button.dataset.day : button.dataset.night;
        button.setAttribute('aria-label', mode === 'night' ? button.dataset.useDay : button.dataset.useNight);
      });
      document.querySelectorAll('a[data-sdp-main-site-link]').forEach(link => {
        const destination = new URL(link.href);
        if (destination.origin !== 'https://platanosbaseball.com') return;
        destination.searchParams.set('mode', mode);
        link.href = destination.href;
      });
    }
    document.querySelectorAll('.sdp-shell__mobile-menu').forEach(menu => {
      if (menu.dataset.menuReady) return;
      menu.dataset.menuReady = 'true';
      const summary = menu.querySelector('summary');
      menu.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || !menu.open) return;
        event.preventDefault();
        menu.open = false;
        summary.focus();
      });
      document.addEventListener('click', event => {
        if (menu.open && !menu.contains(event.target)) menu.open = false;
      });
    });
    let mode = 'day';
    try { mode = localStorage.getItem('sdp-w2-native-mode') === 'night' ? 'night' : 'day'; } catch {}
    const requestedMode = new URLSearchParams(window.location.search).get('mode');
    if (requestedMode === 'day' || requestedMode === 'night') {
      mode = requestedMode;
      try { localStorage.setItem('sdp-w2-native-mode', mode); } catch {}
    }
    sync(mode);
    buttons.forEach(button => {
      if (button.dataset.modeReady) return;
      button.dataset.modeReady = 'true';
      button.addEventListener('click', () => {
        const next = document.documentElement.dataset.sdpMode === 'night' ? 'day' : 'night';
        sync(next);
        try { localStorage.setItem('sdp-w2-native-mode', next); } catch {}
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('mode', next);
        window.history.replaceState(window.history.state, '', currentUrl.href);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSdpMode);
  else initSdpMode();
  document.addEventListener('shopify:section:load', initSdpMode);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdp-brand-shell"] && !Shopify.designMode) return;
  try {
    
  function initSdpMode() {
    const buttons = document.querySelectorAll('[data-sdp-mode-toggle]');
    if (/\/policies\/(?:shipping|refund)-policy\/?$/.test(window.location.pathname)) {
      const orderHelpLinks = '.shopify-policy__body a[href="https://platanosbaseball.com/ayuda/pedidos"], .shopify-policy__body a[href="https://platanosbaseball.com/en/help/orders"]';
      document.querySelectorAll(orderHelpLinks).forEach(link => link.setAttribute('data-sdp-main-site-link', ''));
    }
    function sync(mode) {
      document.documentElement.dataset.sdpMode = mode;
      buttons.forEach(button => {
        button.setAttribute('aria-pressed', String(mode === 'night'));
        button.textContent = mode === 'night' ? button.dataset.day : button.dataset.night;
        button.setAttribute('aria-label', mode === 'night' ? button.dataset.useDay : button.dataset.useNight);
      });
      document.querySelectorAll('a[data-sdp-main-site-link]').forEach(link => {
        const destination = new URL(link.href);
        if (destination.origin !== 'https://platanosbaseball.com') return;
        destination.searchParams.set('mode', mode);
        link.href = destination.href;
      });
      const localeReturnUrl = new URL(window.location.href);
      localeReturnUrl.searchParams.set('mode', mode);
      document.querySelectorAll('#SdpEnglishLocaleForm input[type="hidden"][name="return_to"], #SdpSpanishLocaleForm input[type="hidden"][name="return_to"]').forEach(input => {
        input.value = localeReturnUrl.pathname + localeReturnUrl.search + localeReturnUrl.hash;
      });
    }
    document.querySelectorAll('.sdp-shell__mobile-menu').forEach(menu => {
      if (menu.dataset.menuReady) return;
      menu.dataset.menuReady = 'true';
      const summary = menu.querySelector('summary');
      menu.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || !menu.open) return;
        event.preventDefault();
        menu.open = false;
        summary.focus();
      });
      document.addEventListener('click', event => {
        if (menu.open && !menu.contains(event.target)) menu.open = false;
      });
    });
    let mode = 'day';
    try { mode = localStorage.getItem('sdp-w2-native-mode') === 'night' ? 'night' : 'day'; } catch {}
    const requestedMode = new URLSearchParams(window.location.search).get('mode');
    if (requestedMode === 'day' || requestedMode === 'night') {
      mode = requestedMode;
      try { localStorage.setItem('sdp-w2-native-mode', mode); } catch {}
    }
    sync(mode);
    buttons.forEach(button => {
      if (button.dataset.modeReady) return;
      button.dataset.modeReady = 'true';
      button.addEventListener('click', () => {
        const next = document.documentElement.dataset.sdpMode === 'night' ? 'day' : 'night';
        sync(next);
        try { localStorage.setItem('sdp-w2-native-mode', next); } catch {}
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('mode', next);
        window.history.replaceState(window.history.state, '', currentUrl.href);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSdpMode);
  else initSdpMode();
  document.addEventListener('shopify:section:load', initSdpMode);
  function initSdpPolicyHeading() {
    const normalize = text => text.trim().replace(/\s+/g, ' ').toLowerCase();
    document.querySelectorAll('.shopify-policy__container').forEach(policy => {
      const title = policy.querySelector('.shopify-policy__title h1');
      const body = policy.querySelector('.shopify-policy__body');
      const content = body?.firstElementChild?.classList.contains('rte') ? body.firstElementChild : body;
      const heading = content?.firstElementChild;
      if (!title || title.getAttribute('aria-hidden') === 'true' || !title.getClientRects().length ||
          !heading || heading.tagName !== 'H2' || heading.childElementCount || heading.id) return;
      const titleText = normalize(title.textContent);
      if (titleText && normalize(heading.textContent) === titleText) {
        heading.dataset.sdpPolicyTitleDuplicate = 'true';
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSdpPolicyHeading);
  else initSdpPolicyHeading();
  document.addEventListener('shopify:section:load', initSdpPolicyHeading);

  } catch(e) { console.error(e); }
})();
})();
